export const LICENSE_SCOPES = ['pro', 'premium'];
export const PRODUCT_SCOPES = ['data-grid', 'date-pickers', 'charts', 'tree-view'];
export const PLAN_VERSIONS = ['initial', 'Q3-2024'];
export const extractProductScope = packageName => {
  // extract the part between "x-" and "-pro"/"-premium"
  const regex = /x-(.*?)(-pro|-premium)?$/;
  const match = packageName.match(regex);
  return match[1];
};
export const extractAcceptedScopes = packageName => {
  return packageName.includes('premium') ? LICENSE_SCOPES.filter(scope => scope.includes('premium')) : LICENSE_SCOPES;
};